import type { ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark = ({ className }: LogoMarkProps): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' fill='none' aria-hidden='true' className={cn('size-9', className)}>
            <rect width='64' height='64' rx='18' fill='#39367A' />
            <path d='M14 22.5c5.6-2.6 11.4-2.4 17 .8v23c-5.6-3.2-11.4-3.4-17-.8v-23Z' fill='#FFFFFF' />
            <path d='M50 22.5c-5.6-2.6-11.4-2.4-17 .8v23c5.6-3.2 11.4-3.4 17-.8v-23Z' fill='#FFFFFF' fillOpacity='0.62' />
            <path d='M46.5 8.5l1.5 3.9 3.9 1.5-3.9 1.5-1.5 3.9-1.5-3.9-3.9-1.5 3.9-1.5 1.5-3.9Z' fill='#CBC7FF' />
        </svg>
    )
}

interface LogoProps {
    className?: string
    tone?: 'dark' | 'light'
}

const Logo = ({ className, tone = 'dark' }: LogoProps): ReactNode => {
    return (
        <Link
            href='/'
            aria-label={`${siteConfig.name}، صفحه اصلی`}
            className={cn('group inline-flex items-center gap-2.5 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60', className)}
        >
            <LogoMark className='transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105' />
            <span className='flex flex-col leading-none'>
                <span className={cn('text-lg font-extrabold leading-tight', tone === 'light' ? 'text-white' : 'text-foreground')}>
                    {siteConfig.name}
                </span>
                <span className={cn('font-mono text-[10px] uppercase leading-tight', tone === 'light' ? 'text-white/50' : 'text-muted-foreground/80')}>
                    {siteConfig.latinName}
                </span>
            </span>
        </Link>
    )
}

export default Logo
